export default __webpack_public_path__ + "static/img/exhib-02.52d2803.png";